import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Storage from '../api/Storage'
import Language from './Language'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: Storage.language,
  fallbackLocale: 'en',
  messages: Language
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js